module.exports = __webpack_public_path__ + "img/contacting_employer.533e0b98.jpg";